export const MAX_RESPONSIVE_MOBILE = 768;
